import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import { FormType } from '../../common/types/formTypes';
import { UserAuthorizationItemType } from '../../../api/userAuthorizationTypes';
import UserAuthorizationViewModal from './modal/UserAuthorizationViewModal';
import UserAuthorizationModal from './modal/UserAuthorizationModal';
import DeleteConfirmationModal from '../../common/modal/DeleteConfirmationModal';
import ConfigContext from '../../../contexts/ConfigContext';
import { deleteUserAuthorization } from '../../../api/userAuthorization';
import NinModal from '../../common/modal/NinModal';
import { sendToast } from '../../../utils/displayUtils';

type UserAuthorizationMenuProps = {
    userAuthorization: UserAuthorizationItemType;
    onSubmit?: () => void;
    refresh: () => void;
};

const UserAuthorizationMenu = (props: UserAuthorizationMenuProps) => {
    const config = useContext(ConfigContext);

    return (
        <ul className="dropdown-menu dropdown-menu-right">
            <li>
                <NinModal
                    button={
                        <Button
                            variant="button"
                            className="dropdown-menu-modal-toggle dropdown-item"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            View AM View Authorization
                        </Button>
                    }
                    render={(toggleModal: () => void) => (
                        <UserAuthorizationViewModal
                            userAuthorization={props.userAuthorization}
                            toggleModal={toggleModal}
                        />
                    )}
                />
            </li>

            <li role="separator" className="dropdown-divider" />
            <li>
                <UserAuthorizationModal
                    title="Edit View Authorization"
                    toggleButton={
                        <Button
                            variant="button"
                            type="button"
                            className="dropdown-menu-modal-toggle"
                        >
                            Edit View Authorization
                        </Button>
                    }
                    formType={FormType.UPDATE}
                    userAuthorization={props.userAuthorization}
                    onSubmit={props.onSubmit}
                />
            </li>
            <li>
                <UserAuthorizationModal
                    title="Copy View Authorization"
                    toggleButton={
                        <Button
                            variant="button"
                            type="button"
                            className="dropdown-menu-modal-toggle"
                        >
                            Copy View Authorization
                        </Button>
                    }
                    formType={FormType.CLONE}
                    userAuthorization={props.userAuthorization}
                    onSubmit={props.onSubmit}
                />
            </li>
            {props.userAuthorization.id && (
                <li>
                    <DeleteConfirmationModal
                        title="Delete View Authorization"
                        onConfirm={async () => {
                            if (props.userAuthorization.id) {
                                await deleteUserAuthorization(config, props.userAuthorization.id);
                                sendToast(
                                    <>
                                        Deleted View Authorization:{' '}
                                        <strong>{props.userAuthorization.personName}</strong>
                                    </>,
                                );
                                props.refresh();
                            }
                        }}
                        body="Please confirm that you would like to delete this view authorization. "
                        toggleButton={
                            <Button
                                variant="button"
                                className="dropdown-menu-modal-toggle dropdown-item"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <span className="text-danger">Delete View Authorization</span>
                            </Button>
                        }
                        confirmButtonText="Confirm Delete"
                    />
                </li>
            )}
        </ul>
    );
};

export default UserAuthorizationMenu;
